/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WatchlistModelListResult } from '../../models/watchlist-model-list-result';

export interface ApiWatchlistGet$JsonOdataMetadataNone$Params {
  UserId?: number;
}

export function apiWatchlistGet$JsonOdataMetadataNone(http: HttpClient, rootUrl: string, params?: ApiWatchlistGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<WatchlistModelListResult>> {
  const rb = new RequestBuilder(rootUrl, apiWatchlistGet$JsonOdataMetadataNone.PATH, 'get');
  if (params) {
    rb.query('UserId', params.UserId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=none', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WatchlistModelListResult>;
    })
  );
}

apiWatchlistGet$JsonOdataMetadataNone.PATH = '/api/watchlist';
